var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcApple = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    viewBox: "0 0 17 16",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.395 11.43a8 8 0 0 1-.789 1.418q-.622.886-1.015 1.227-.608.559-1.306.575-.502 0-1.206-.288-.705-.287-1.298-.287-.622 0-1.335.287-.714.29-1.154.303-.668.03-1.335-.59-.425-.37-1.062-1.27a8.8 8.8 0 0 1-1.123-2.232Q2.3 9.2 2.3 7.913q0-1.474.638-2.541.501-.855 1.335-1.351a3.6 3.6 0 0 1 1.806-.51q.532.001 1.397.325.864.325 1.108.326.183 0 1.229-.384.986-.355 1.67-.296 1.85.149 2.777 1.462-1.656 1.004-1.639 2.807.016 1.404 1.017 2.333.453.43 1.016.666-.122.354-.26.68M11.565.294q0 1.1-.802 2.052c-.645.753-1.425 1.189-2.27 1.12a2 2 0 0 1-.017-.278c0-.704.307-1.458.85-2.074a3.3 3.3 0 0 1 1.037-.778Q10.992.029 11.55 0q.015.147.015.294"
  })));
};
export default SvgIcApple;